export const en = {
  archiveTasks: ({ all, size }) => `Archive ${all ? 'all' : size} Tasks`,
  reallyArchive: 'Really archive?',
  createBulkRequestFailure: 'Tasks could not be archived. Please try again.',
  createBulkRequestSuccess: 'Tasks archived successfully.',
  archiveSelectedTasks: 'Archive selected Tasks',
  markAllAsReadSuccess: 'All comments marked as read',
  markAllAsReadFailure: 'Something went wrong',
  containsTaks:
    "This column can't be deleted because it contains tasks. Try removing all of the tasks from the column and ensure you aren't filtering the tasks via the search or by user.",
  minColumns:
    "This column can't be deleted because a minimum of two columns is required.",
  addTask: 'Add Task',
  addColumn: 'Add Column',
  renameColumn: 'Rename Column',
  markAllAsRead: 'Mark all as read',
  deleteColumn: 'Delete Column'
};
